function splitObjectTypeWords(objectType: string): string {
  return objectType.replace(/([A-Z])/g, ' $1').trim();
}

export function getTitleCasedObjectTypeLabel(objectType: string): string {
  const words = splitObjectTypeWords(objectType);
  if (words === '') {
    return '';
  }
  return `${words.charAt(0).toUpperCase()}${words.slice(1)}`;
}

// Initialisms (e.g. "RNA") are read letter-by-letter, so the article depends on how the
// first letter's *name* sounds, not its spelling. These letters' names start with a vowel
// sound (e.g. "R" → "are", "F" → "eff"), so an initialism beginning with one takes "an".
const VOWEL_SOUND_INITIAL_LETTERS = new Set(['A', 'E', 'F', 'H', 'I', 'L', 'M', 'N', 'O', 'R', 'S', 'X']);

export function withIndefiniteArticle(noun: string): string {
  const firstWord = noun.split(' ')[0] ?? '';
  const isInitialism = firstWord.length > 1 && /^[A-Z]+$/.test(firstWord);
  const startsWithVowelSound = isInitialism
    ? VOWEL_SOUND_INITIAL_LETTERS.has(firstWord.charAt(0))
    : /^[aeiou]/i.test(noun);
  return startsWithVowelSound ? `an ${noun}` : `a ${noun}`;
}

export function toCommonNounLabel(label: string): string {
  return label
    .split(' ')
    .map((word) => (word === word.toUpperCase() ? word : word.toLowerCase()))
    .join(' ');
}
